import type { User } from "firebase/auth";

export function isVerifiedGoogleUser(user: User) {
  return user.emailVerified && Boolean(user.email?.trim());
}
